// jshint ignore: start

export default {
  "seo": {
    "indexTitle": "3D AI Generator | CGTrader",
    "galleryTitle": "AI 3D Models Generated By Community | CGTrader AI",
    "outputTitle": "{{name}} 3D model | CGTrader AI"
  },
  "waitlist": {
    "card": {
      "chip": "Free beta",
      "freeGenerationsHighlight": "5 Free Generations",
      "freeGenerationsSuffix": " in CGTrader AI",
      "noCreditCard": "No credit card is required",
      "gettingStarted": "Great for getting started and trying things out",
      "join": "Join the Waitlist",
      "joining": "Joining...",
      "haveAccessCode": "I have access code",
      "joinError": "Could not join the waitlist. Please try again."
    },
    "accessCode": {
      "label": "Enter the code for free beta access",
      "placeholder": "Enter your code",
      "apply": "Apply",
      "applying": "Applying...",
      "successMessage": "Setting up your access -- we'll notify you once it's ready.",
      "invalidMessage": "Invalid access code. Please try again.",
      "errorMessage": "Could not validate the access code. Please try again."
    },
    "subscriptionBullets": {
      "monthly": "{{monthlyModels}} CGTrader AI generations or Marketplace downloads",
      "editEnhance": "Edit and enhance your own or purchased 3D models",
      "engines": "All top AI engines included: Tripo, Hunyuan, Meshy",
      "allAdvancedFeatures": "Access to all advanced features"
    }
  },
  "bestOnDesktop": {
    "title": "Best on Desktop",
    "description": "CGTrader AI is designed for larger screens. Some editing tools, settings, and 3D previews may not display correctly on mobile. For the best experience, please switch to a desktop."
  },
  "mobileTabBar": {
    "tabs": {
      "generate": "Generate",
      "viewer": "3D Model",
      "enhance": "Enhance"
    }
  },
  "sidebar": {
    "header": {
      "title": "CGTrader AI"
    },
    "linkNav": {
      "generate": "Generate 3D Model",
      "communityGallery": "Community Gallery"
    },
    "usage": {
      "label": "Usage"
    },
    "termsOfService": {
      "label": "Terms of Service"
    },
    "status": {
      "processing": "Processing...",
      "generating": "Generating..."
    },
    "actions": {
      "generateNewModel": "Generate New 3D Model"
    },
    "search": {
      "placeholder": "Search"
    },
    "filtering": {
      "generated": "Generated",
      "purchased": "Purchased",
      "uploaded": "Uploaded",
      "all": "All",
      "favorites": "Favorites",
      "drafts": "Drafts"
    },
    "library": {
      "error": "Failed to load!",
      "emptyState": {
        "text": "Create your first 3D Model and your library will appear here"
      },
      "notFound": {
        "text": "Nothing found"
      }
    },
    "modelCard": {
      "draft": "Draft",
      "makePrivate": "Make Private",
      "created": "Created: {{date}}",
      "delete": "Delete"
    },
    "newModelCard": {
      "titleLine1": "Generate New",
      "titleLine2": "3D Model"
    }
  },
  "imageAssistantPanel": {
    "title": "AI Assistant",
    "subtitle": "Create or select a reference image to improve 3D results",
    "tabs": {
      "search": "Search",
      "create": "Create",
      "edit": "Edit"
    },
    "actions": {
      "applyAndContinue": "Apply and continue",
      "regenerate": "Regenerate",
      "editImage": "Edit image",
      "modifyImage": "Modify image"
    },
    "createTab": {
      "conversation": {
        "emptyPrompt": "What would you like to create?"
      },
      "generatingState": {
        "label": "Creating your image..."
      },
      "failedState": {
        "title": "Generation failed",
        "text": "Something went wrong while generating your image. Please try again.",
        "retry": "Generate again"
      }
    },
    "editTab": {
      "emptyState": {
        "title": "To edit an image upload, search or create it first",
        "subtitle": "Supports text instructions and inpainting"
      },
      "toolbar": {
        "history": "History"
      }
    },
    "searchTab": {
      "searchPlaceholder": "Search reference images",
      "categoriesHeading": "The most searched image categories",
      "loading": "Loading search results...",
      "noResults": {
        "title": "Nothing found",
        "subtitle": "Try creating a reference image using your prompt",
        "create": "Create Image"
      }
    }
  },
  "usageModal": {
    "header": {
      "unlockAiGeneration": "Unlock AI Generation",
      "betaAccessRequested": "Beta access requested",
      "aiUsage": "CGTrader AI Usage"
    },
    "tags": {
      "freePlan": "Free plan",
      "subscription": "CGTrader Subscription"
    },
    "setupHeadline": "You've set everything up - now unlock generation to bring it to life.",
    "terms": {
      "leadDefault": "By continuing using CGTrader AI you agree to the",
      "leadWaitlisted": "By continuing I agree to the",
      "tosLink": "CGTrader AI Terms of Service"
    },
    "extraUsage": {
      "titleWithPrice": "Get {{count}} More Generations for {{price}}",
      "title": "Get {{count}} More Generations",
      "subtitle": "Keep creating without interruptions",
      "cta": "Buy Extra Usage",
      "note": "Extra Usage does not expire or reset monthly."
    },
    "freeBeta": {
      "outOfGenerations": "You're out of free generations",
      "almostOutOfGenerations": "You're almost out of free generations",
      "generationsUsedLabel": "Generations used"
    },
    "freeBetaCard": {
      "successMessage": "You're all set! Start creating your 3D models.",
      "errorMessage": "Could not start your free beta. Please try again.",
      "chip": "Free beta",
      "freeGenerations": "5 Free Generations",
      "inStudio": " in CGTrader AI Studio",
      "noCreditCard": "No credit card required",
      "gettingStarted": "Great for getting started and trying things out",
      "starting": "Starting...",
      "cta": "Start Creating for Free"
    },
    "hasCredits": {
      "creditsLeft": "You have {{count}} credit left",
      "creditsLeft_plural": "You have {{count}} credits left"
    },
    "subscribed": {
      "outOfGenerations": "You're out of generations",
      "monthlyGenerationsUsedLabel": "Monthly Generations used",
      "extraGenerationsUsedLabel": "Extra Generations used",
      "resetDateLabel": "Reset date:",
      "subscriptionSettings": "Go to Subscription Settings"
    },
    "subscriptionCard": {
      "priceUnit": "/ month",
      "cta": "Get Subscription"
    },
    "upgrade": {
      "title": "Upgrade to Start Creating"
    },
    "upgradeCard": {
      "defaultTitle": "Upgrade to Keep Creating",
      "priceUnit": "/ month",
      "cta": "Get Subscription"
    },
    "paidFeature": {
      "title": "Upgrade to Create with More Freedom",
      "advancedFeaturesTitle": "Unlock advanced features:",
      "advancedFeatures": {
        "private": "Keep your models private so only you can view and share them",
        "dccBridge": "DCC Bridge integration for a seamless workflow",
        "export": "Export models in any supported format",
        "multipleModels": "Generate multiple models simultaneously"
      }
    },
    "waitlisted": {
      "onWaitlist": "You're on the waitlist!",
      "copy": "We'll review your request and notify you by email once access is available.",
      "accessCode": "I have access code",
      "upgradeTitle": "Faster access with Subscription"
    }
  },
  "viewerSidebar": {
    "nav": {
      "enhance3dModel": "Enhance 3D Model",
      "remesh": "Remesh",
      "texture": "Texture",
      "segment": "Segment",
      "animate": "Animate",
      "render": "Render",
      "variations": "Variations",
      "assist": "Assist",
      "disabledReason": "Generate or upload a model to start editing it",
      "variationsNotOwnerReason": "Variations are available only for your own models"
    },
    "enhance": {
      "common": {
        "done": "Done",
        "processing": "Processing..."
      },
      "remesh": {
        "title": "Remesh",
        "generateLabel": "Remesh",
        "smartLowPoly": "Smart low poly",
        "polycount": {
          "label": "Polycount",
          "low": "Low",
          "medium": "Medium",
          "high": "High"
        },
        "example": {
          "highPoly": "High-poly Mesh",
          "optimized": "Optimized Mesh"
        }
      },
      "texture": {
        "title": "Texture",
        "generateLabel": "Generate Texture",
        "textPlaceholder": "Describe the texture you want to generate for this model",
        "material": {
          "label": "Material",
          "pbr": "PBR",
          "basic": "Basic Material"
        },
        "preview": {
          "initial": "Initial texture",
          "new": "New texture"
        }
      },
      "segment": {
        "title": "Segmentation",
        "riggedTooltip": "Segmentation is unavailable for rigged models.",
        "placeholderTitle": "Segmentation",
        "placeholderDescription": "Automatically segment your 3D model into editable parts",
        "explodedView": "Exploded View",
        "resetModel": "Reset Model",
        "partList": "Part list",
        "generateLabel": "Start Segmenting",
        "generatingLabel": "Segmenting...",
        "unavailable": {
          "title": "Unavailable for",
          "quad": "Quad models",
          "rigged": "Rigged models"
        }
      },
      "animate": {
        "title": "Animate",
        "description": "Animate your 3D model with intelligent motion controls"
      },
      "render": {
        "title": "Render 2D",
        "description": "Create high-quality renders of your 3D model in seconds"
      },
      "variations": {
        "title": "Variations",
        "emptyState": "Enhance or regenerate your model. New Variations will appear here.",
        "uploaded": "Uploaded",
        "menu": {
          "created": "Created: {{date}}",
          "setAsMain": "Set as main",
          "delete": "Delete"
        },
        "notifications": {
          "setAsMainSuccess": "\"{{name}}\" set as main successfully",
          "setAsMainError": "Failed to set variation as main. Please try again.",
          "deleteSuccess": "\"{{name}}\" deleted successfully",
          "deleteError": "Failed to delete variation. Please try again."
        }
      },
      "assist": {
        "heading": "Request for Designer Assistance",
        "placeholderDescription": "Get help from a real designer whenever you need it",
        "form": {
          "title": {
            "label": "Title",
            "placeholder": "Type here..."
          },
          "description": "Description",
          "budget": "Budget",
          "resell": "I allow the designer to sell Project results on the marketplace",
          "terms": {
            "agree": "I agree with the ",
            "link": "Terms and Conditions"
          },
          "submit": "Post a Project",
          "loadSoftwareError": "Failed to load 3D software",
          "submitError": "Something went wrong, please try again"
        },
        "deadline": {
          "label": "Deadline",
          "noFixed": "No fixed deadline"
        },
        "software": {
          "label": "3D Software",
          "placeholder": "Select 3D Software"
        },
        "references": {
          "label": "Visual references",
          "note": "We'll share the inputs used. You can also add references.",
          "untitledModel": "Untitled model",
          "dropzone": {
            "title": "Drag reference images here",
            "or": "or",
            "browse": "Browse"
          },
          "errors": {
            "uploadFailed": "Your file failed to attach. Please try again or contact our support",
            "onlyImages": "Only image files can be attached.",
            "tooBig": "Attachment is too big, please try to not exceed 100MBs.",
            "duplicate": "You cannot attach file with the same filename"
          }
        },
        "posted": {
          "title": "Request submitted",
          "description": "Your project has been posted to the open list for freelance designers. You'll be notified when someone applies",
          "cta": "Go to My 3D Projects"
        }
      }
    }
  },
  "shared": {
    "aiEngine": {
      "label": "AI Engine",
      "disabledTooltip": "Not available for this settings combination"
    },
    "polyCount": {
      "label": "Polycount",
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "polygonType": {
      "label": "Polygon Type",
      "quad": "Quad",
      "triangular": "Triangular"
    },
    "placeholder": {
      "comingSoon": "Coming soon"
    },
    "subscribersOnly": {
      "title": "For Subscribers Only",
      "simultaneousGenerationsTitle": "Multiple simultaneous generations are available to Subscribers only",
      "getSubscription": "Get Subscription"
    },
    "uploadModel": {
      "uploading": "Uploading...",
      "upload": "Upload 3D Model"
    },
    "shareContent": {
      "embedButtonLabel": "Embed this 3D Model"
    },
    "generateButton": {
      "inProgressTooltip": "Another generation is currently in progress. This action will be available once it has completed.",
      "limitReachedTooltip": "You've reached the maximum number of active generations. This action will be available once one is complete.",
      "genericError": "Generation failed. Please try again."
    },
    "privateMode": {
      "label": "Private Mode",
      "tooltip": "In Private Mode, only you can view and share the model. If Private Mode is not enabled, the model may be displayed in the community gallery, where other users can view and remix it."
    },
    "actionSelector": {
      "tabs": {
        "image": "Image",
        "text": "Text"
      },
      "textInstructions": {
        "maxCharacters": "Maximum {{maxLength}} characters allowed"
      },
      "imageUploader": {
        "uploadPrompt": {
          "dropHere": "Drop your image here or",
          "browse": "browse",
          "fileTypes": "PNG, JPG, WEBP"
        },
        "pasteUrl": {
          "placeholder": "Image URL",
          "upload": "Upload image"
        },
        "ideation": {
          "search": "Search Image",
          "create": "Create Image",
          "edit": "Edit Image"
        }
      }
    },
    "composer": {
      "placeholder": "Describe the object and view (e.g., electric sports car, front 3/4 view)"
    },
    "dccNotification": {
      "connecting": "Connecting plugin...",
      "sending": "Sending 3D Model to {{name}}...",
      "success": "3D Model is sent to {{name}}",
      "pluginNotRunning": {
        "title": "Plugin is not running",
        "descriptionWithName": "Make sure your DCC is open and the plugin is installed and running for {{name}}.",
        "description": "Make sure your DCC is open and the plugin is installed and running."
      },
      "dccBusy": {
        "title": "DCC is busy",
        "description": "It's still processing a previous import. Please try again in a moment."
      },
      "error": {
        "title": "Something went wrong",
        "description": "There was a problem sending your model. Please try again."
      }
    },
    "deleteConfirmModal": {
      "header": "Delete {{itemType}}?",
      "submit": "Delete",
      "cancel": "Cancel",
      "bodyNamed": "\"{{itemName}}\" will be permanently deleted. This action cannot be undone.",
      "bodyGeneric": "This {{itemType}} will be permanently deleted. This action cannot be undone.",
      "itemTypes": {
        "item": "item",
        "model": "model",
        "variation": "variation",
        "comment": "comment",
        "reply": "reply"
      }
    },
    "exportNotification": {
      "queued": {
        "title": "The file has been added to the queue.",
        "description": "Your export will start shortly."
      },
      "preparing": {
        "title": "Preparing your file for download."
      },
      "error": {
        "title": "Something went wrong",
        "description": "We couldn't complete the export. Please try again."
      }
    }
  },
  "leftSide": {
    "generate": {
      "generate": "Generate 3D Model",
      "regenerate": "Regenerate 3D Model",
      "generated": "Generated",
      "generating": "Generating..."
    },
    "modelSettings": {
      "promptPlaceholder": "Describe what you want to create"
    },
    "useCase": {
      "title": "Use case",
      "options": {
        "standard": {
          "title": "Standard",
          "description": "Good for most cases. Balanced quality and polygon count with PBR textures."
        },
        "hero": {
          "title": "Hero asset",
          "description": "Maximum quality. Dense quad mesh with full PBR - ideal for high quality assets."
        },
        "prop": {
          "title": "Prop asset",
          "description": "Game-ready prop with medium polygon count."
        },
        "threeDPrint": {
          "title": "3D print",
          "description": "High density triangulated mesh for 3D printing with basic material."
        },
        "shapeOnly": {
          "title": "Shape only",
          "description": "High density mesh with no textures. Ideal for validating geometry and surface detail."
        },
        "lowPoly": {
          "title": "Low Poly",
          "description": "Low polygon count mesh with PBR textures."
        }
      }
    },
    "material": {
      "label": "Material",
      "pbr": "PBR",
      "basic": "Basic",
      "geometryOnly": "Geometry only",
      "geometry": "Geometry"
    },
    "smartLowPoly": {
      "label": "Smart low poly",
      "collapsedLabel": "Low poly"
    },
    "advancedSettings": {
      "trigger": "Advanced settings"
    },
    "polyCount": {
      "label": "Polycount",
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "polygonType": {
      "label": "Polygon Type",
      "quad": "Quad",
      "triangular": "Triangular"
    },
    "aiEngine": {
      "label": "AI Engine"
    },
    "actionPreview": {
      "title": "Input"
    }
  },
  "header": {
    "modelSettings": "Generate 3D Model",
    "viewer": "3D Model"
  },
  "community": {
    "card": {
      "remix": "Remix {{title}}",
      "remixBy": "Remix {{title}} by {{username}}"
    }
  },
  "commentsModal": {
    "ariaLabel": "Comments",
    "placeholder": "Feel free to share your thoughts here.",
    "replyPlaceholder": "Write your reply here",
    "post": "Post",
    "reply": "Reply",
    "delete": "Delete",
    "deleteCommentBy": "Delete comment by {{username}}",
    "deleteReplyBy": "Delete reply by {{username}}",
    "relativeTime": {
      "year": "{{count}} y",
      "month": "{{count}} mo",
      "week": "{{count}} w",
      "day": "{{count}} d",
      "hour": "{{count}} h",
      "minute": "{{count}} min",
      "second": "{{count}} s"
    },
    "hide": "Hide",
    "creatorBadge": "Creator of the model",
    "commentsCount": "{{count}} Comment",
    "commentsCount_plural": "{{count}} Comments",
    "repliesCount": "{{count}} Reply",
    "repliesCount_plural": "{{count}} Replies",
    "empty": "No comments yet. Be the first to share your thoughts.",
    "loadError": "Failed to load comments.",
    "submitError": "Something went wrong. Please try again.",
    "limitReached": "You've reached the commenting limit for now. Please try again later.",
    "loginPrompt": "Log in to join the conversation.",
    "login": "Log in"
  },
  "footerActions": {
    "delete": "Delete",
    "share": "Share",
    "creator": {
      "createdBy": "Created by {{username}}"
    },
    "export": {
      "label": "Export"
    },
    "dccBridge": {
      "tooltip": "Install and run the plugin first to send models to the corresponding DCC software",
      "comingSoon": "Coming soon",
      "downloadPluginButton": "Download Plugin",
      "guide": "Guide"
    },
    "sendTo": {
      "label": "Send to",
      "labelWithName": "Send to {{name}}",
      "needHelp": "Need help?",
      "setupGuide": "See setup guide",
      "downloadPlugin": "Download plugin",
      "step1": "Download and install the plugin",
      "step2": "Launch your DCC and make sure the plugin is running",
      "step3": "Send your model directly to your DCC."
    },
    "modelTitle": {
      "updateSuccess": "Model title updated successfully.",
      "updateError": "Failed to update model title."
    }
  },
  "viewer": {
    "banner": {
      "initial": "Your 3D Model will appear here",
      "generatingTitle": "Generating your 3D model",
      "generatingDescription": "This may take a few minutes. You'll see an indicator in the top menu when it's ready. We'll also send you an email so you don't miss it.",
      "loadingTitle": "Loading 3D model",
      "uploadingTitle": "Uploading your 3D model...",
      "uploadingDescription": "This may take a moment. Complex models may take longer to load.",
      "cleverPush": {
        "prompt": "Get notified even when you switch tabs",
        "allow": "Allow Browser Notifications"
      },
      "relatedProducts": {
        "title": "You may also like",
        "viewMore": "View more in Marketplace"
      }
    },
    "errorBanner": {
      "tryAgain": "{{action}} Again",
      "title": "Something went wrong",
      "description": "We couldn't complete this action. Try adjusting settings, simplifying your input, or checking references.",
      "errorId": "ERROR ID",
      "reason": "REASON",
      "message": "MESSAGE",
      "providerCode": "PROVIDER CODE"
    },
    "modelReadyToaster": {
      "message": "Your model is ready! Now explore Enhance tools to refine and customize it.",
      "dontShowAgain": "Don't show again"
    },
    "remixNotice": {
      "title": "You are in Remix Mode",
      "description": "Adjust settings, regenerate, and enhance this 3D model to create your own version. New creations will be saved to your library.",
      "tag": "Remix Mode"
    },
    "termsOfServiceNotice": {
      "lead": "Please note that by continuing to use CGTrader AI, you agree to the",
      "link": "CGTrader AI Terms of Service"
    },
    "canvas": {
      "failedToStart": "Failed to start"
    },
    "environment": {
      "title": "Environment settings",
      "strength": "Strength",
      "rotation": "Rotation",
      "uploadHdri": "Upload HDRI",
      "surrounding": "Surrounding",
      "showDefaultHdri": "Show Default HDRI",
      "showHdri": "Show HDRI",
      "uploadFailed": "HDRI upload failed. Please try again.",
      "added": "\"{{label}}\" added to surroundings."
    },
    "sidebar": {
      "lighting": "Lighting (L)",
      "toggleGrid": "Toggle grid (G)",
      "autoRotate": "Toggle auto rotate (R)",
      "resetCamera": "Reset camera (F)"
    },
    "renderMode": {
      "pbr": "PBR (M)",
      "clay": "Clay (C to cycle)",
      "baseColor": "Base color only (C to cycle)",
      "roughness": "Roughness only (C to cycle)",
      "normals": "Normals only (C to cycle)",
      "metalness": "Metalness only (C to cycle)",
      "segmentation": "Segmentation (C to cycle)",
      "wireframe": "Wireframe (W)"
    },
    "modelDetails": {
      "topology": "Topology",
      "faces": "Faces",
      "vertices": "Vertices",
      "aiEngine": "AI Engine",
      "lowPoly": "Low poly",
      "polycount": "Polycount",
      "polygonType": "Polygon Type",
      "material": "Material",
      "true": "True",
      "false": "False",
      "materialBasic": "Basic",
      "materialGeometryOnly": "Geometry Only"
    }
  },
  "signIn": {
    "header": {
      "signupTitle": "Create an account to get started",
      "loginTitle": "Welcome back",
      "signupSubtitle": "We will email you a 6-digit code, so you can sign in without having to create the password.",
      "loginSubtitle": "Log in to keep creating, designing and downloading."
    },
    "auth": {
      "divider": "or",
      "optIn": "Get product updates, community news and offers."
    },
    "email": {
      "label": "Email",
      "placeholder": "john@email.com",
      "ariaLabel": "Email address"
    },
    "footer": {
      "submit": "Continue",
      "haveAccount": "Have an account?",
      "noAccount": "Don't have an account?",
      "login": "Log in",
      "signup": "Sign Up"
    },
    "terms": {
      "prefix": "By continuing I agree to the",
      "termsLink": "General Terms & Conditions",
      "and": "and",
      "privacyLink": "Privacy Policy."
    },
    "code": {
      "title": "Check your email",
      "subtitlePrefix": "We've sent a 6-digit code to",
      "yourEmail": "your email",
      "invalidCode": "Invalid access code. Please try again.",
      "resendPrompt": "Didn't receive the email?",
      "resendAction": "Click to resend",
      "digitAriaLabel": "Digit {{index}}"
    },
    "success": {
      "title": "You are in!",
      "loginSubtitle": "You are logged in. Pick up where you left off!",
      "signupSubtitle": "Account created. Generate your first 3D model!"
    },
    "modal": {
      "loginAriaLabel": "Log in to CGTrader AI",
      "signupAriaLabel": "Sign up to CGTrader AI",
      "successAriaLabel": "You are in"
    },
    "password": {
      "link": "Log in with password instead",
      "emailLabel": "Email or Username",
      "title": "Log in with password",
      "subtitle": "Enter your email and password to continue.",
      "passwordLabel": "Password",
      "forgotPassword": "Forgot password?",
      "submit": "Log in",
      "back": "Back",
      "showPassword": "Show password",
      "hidePassword": "Hide password",
      "genericError": "Something went wrong. Please try again later.",
      "requiredNotice": "Please also enter your password to complete the 2FA.",
      "twoFaTitle": "Enter your login verification code",
      "twoFaDescription": "The verification code was sent to the email address you use to log in to your CGTrader account",
      "twoFaVerify": "Verify",
      "twoFaCodeLabel": "Verification code"
    }
  }
}
